<template>
<div id="innovation" class="flex-c">
    <van-image :src="innovation" width="10rem" class="flex-self-ctr"></van-image>
    <van-image :src="logo" width="10rem" class="flex-self-ctr"></van-image>
</div>
</template>

<script>
export default {
    data() {
        return {
            innovation: require('@/assets/innovation.jpg'),
            logo: require('@/assets/logo.gif')
        }
    },
    created() {},
    methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#innovation {
    padding-bottom: 100px;
}
</style>
